import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { TicketActionViewModel } from '../../../core/models/ticket-action-view-model.model';
import { OrderBy } from '@sb-tools/typescript/enums/order-by.enum';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    constructor(private httpClient: HttpClient) {}

    getAll(
        ticketId: number,
        params: { skip: number; take: number; orderBy: OrderBy },
    ): Observable<TicketActionViewModel[]> {
        return this.httpClient.get<TicketActionViewModel[]>(environment.apiInboxUrl + 'tickets/' + ticketId + '/log', {
            params,
        });
    }
}
